/**
 * @generated SignedSource<<1cffceb32deb8c102defe67b747a0471>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type StorefrontCreatorsUrls_featuredCreatorsUrls$data = {
  readonly creatorsUrls: ReadonlyArray<{
    readonly displayName: string | null;
    readonly linkData: {
      readonly " $fragmentSpreads": FragmentRefs<"SeoLink_linkData">;
    };
  } | null> | null;
  readonly " $fragmentType": "StorefrontCreatorsUrls_featuredCreatorsUrls";
};
export type StorefrontCreatorsUrls_featuredCreatorsUrls$key = {
  readonly " $data"?: StorefrontCreatorsUrls_featuredCreatorsUrls$data;
  readonly " $fragmentSpreads": FragmentRefs<"StorefrontCreatorsUrls_featuredCreatorsUrls">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "StorefrontCreatorsUrls_featuredCreatorsUrls",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "CreatorsUrls",
      "kind": "LinkedField",
      "name": "creatorsUrls",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "displayName",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "LinkData",
          "kind": "LinkedField",
          "name": "linkData",
          "plural": false,
          "selections": [
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "SeoLink_linkData"
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "DealerStorefrontQueryConnection",
  "abstractKey": null
};

(node as any).hash = "a244b5a2194b0fcd1823940861b19b43";

export default node;
